import Module from '../Module';
import { $t } from "../i18n";

export default class Contact extends Module {
    constructor(title, index, mandatory, firstQuestion) {
        // Chain constructor with super
        super(title, index, 'contact', firstQuestion);
        this._title = title || $t('mod.contact.title')
        this._firstQuestion = firstQuestion || '';
        this._mandatory = mandatory;
        this._email = '';
        this._salutation = '';
        this._availability = '';
        this._firstName = '';
        this._lastName = '';
        this._phone = '';
        this._street = '';
        this._zip = '';
        this._place = '';
        this._country = '';
    }


    get availability() {
        return this._availability;
    }

    set availability(availability) {
        this._availability = availability;
    }

    get country() {
        return this._country;
    }

    set country(country) {
        this._country = country;
    }

    get city() {
        return this._city;
    }

    set city(city) {
        this._city = city;
    }

    get zip() {
        return this._zip;
    }

    set zip(zip) {
        this._zip = zip;
    }

    get street() {
        return this._street;
    }

    set street(street) {
        this._street = street;
    }

    get lastName() {
        return this._lastName;
    }

    set lastName(lastName) {
        this._lastName = lastName;
    }

    get phone() {
        return this._phone;
    }

    set phone(phone) {
        this._phone = phone;
    }

    get firstName() {
        return this._firstName;
    }

    set firstName(firstName) {
        this._firstName = firstName;
    }

    get salutation() {
        return this._salutation;
    }

    set salutation(salutation) {
        this._salutation = salutation;
    }

    get email() {
        return this._email;
    }

    set email(email) {
        this._email = email;
    }

    get mandatory() {
        return this._mandatory;
    }

    set mandatory(mandatory) {
        this._mandatory = mandatory;
    }

    fillDummyData(store) {
        this.firstName = store.state.formFillData.firstName;
        this.lastName = store.state.formFillData.lastName;
        this.email = store.state.formFillData.email;
        this.salutation = store.state.formFillData.salutation;
        this.phone = '0385 58979790';
        this.country = 'Deutschland';
        this.street = 'Eckdrift 10';
        this.city = 'Schwerin';
        this.zip = '19061';
        this.availability = 'Immer und überall';
    }

    removeDummyData() {
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.salutation = '';
        this.phone = '';
        this.country = '';
        this.street = '';
        this.city = '';
        this.zip = '';
        this.availability = '';
    }
}